export const patternsRegexp = {
  phone: /^[+]?\d+$/,
};
